import { useAddPromocodes } from 'features/add-promocodes';
import { useState } from 'react';
import {
  ArrayInput,
  DateInput,
  Form,
  NumberInput,
  required,
  SaveButton,
  SelectInput,
  SimpleFormIterator,
  useShowContext,
  useRefresh,
  useNotify,
} from 'react-admin';
import { LABELS } from 'shared/constants/labels';
import { VARS } from 'shared/constants/vars';
import styled from 'styled-components';

const promocodeExpireDateDefaultValue = new Date(
  new Date().getFullYear(),
  new Date().getMonth() + 6,
).toISOString();

interface AddPromocodesProps {
  onSuccess?: () => void;
}

export const AddPromocodesForm = ({ onSuccess }: AddPromocodesProps) => {
  const { record } = useShowContext();
  const [promocodeType, setPromocodeType] = useState<string>(VARS.promocodeTypes[0].id);
  const refresh = useRefresh();
  const notify = useNotify();

  const { addPromocodes, isLoading: isLoadingAddPromocodes } = useAddPromocodes({
    companyId: record.id,
  });

  if (record.isArchive) {
    return (
      <Title>Вы не можете добавить промокоды архивированной компании</Title>
    );
  }

  const handleSubmit = ({ promocodes, promocodeExpireDate }: any) => {
    const promocode = promocodes[0];

    if (!promocode) {
      notify('Промокод не может быть пустым', { type: 'error' });
      return;
    }

    const expireDate = new Date(promocodeExpireDate);
    expireDate.setHours(15);

    addPromocodes({
      promocode: {
        quantity: promocode.quantity,
        amount: promocode.amount || undefined,
        percentage: promocode.percentage || undefined,
        expireDate: expireDate.toISOString(),
      },
      userId: record.userId,
    });

    // Обновление списка и отображение уведомления
    setTimeout(() => {
      refresh();
      notify('Промокоды успешно добавлены', { type: 'success' });
      if (onSuccess) {
        onSuccess();
      }
    }, 500);
  };

  return (
    <Form onSubmit={handleSubmit}>
      <ArrayInput source="promocodes" defaultValue={[]} validate={[required()]}>
        <SimpleFormIterator>
          <SelectInput
            value={promocodeType}
            defaultValue={promocodeType}
            onChange={(event) => setPromocodeType(event.target.value)}
            label={LABELS.promocodeType}
            source="type"
            validate={[required()]}
            fullWidth
            choices={VARS.promocodeTypes}
          />
          {
            promocodeType === 'amount' && (
              <NumberInput
                label={LABELS.promocodeAmount}
                source="amount"
                fullWidth
              />
            )
          }
          {
            promocodeType === 'percent' && (
              <NumberInput
                label={LABELS.promocodePercentage}
                source="percentage"
                fullWidth
              />
            )
          }
          <NumberInput
            label={LABELS.promocodeQuantity}
            source="quantity"
            fullWidth
          />
        </SimpleFormIterator>
      </ArrayInput>
      <DateInput
        label={LABELS.promocodeExpireDate}
        source="promocodeExpireDate"
        defaultValue={promocodeExpireDateDefaultValue}
        validate={[required()]}
        fullWidth
      />
      <SaveButton disabled={isLoadingAddPromocodes} />
    </Form>
  );
};

const Title = styled.h2`
  text-align: center;
  font-family: sans-serif;
  color: #494848;
`;
